/**
 * Which app surface the UI is currently showing.
 *
 * Read from the root `dark` class rather than from `useTheme()`, because the
 * callers are plain request builders rather than components. next-themes writes
 * that class (`attribute="class"`), and it is already resolved, so "system"
 * needs no second interpretation here.
 */
export type ColorScheme = 'light' | 'dark'

export function currentColorScheme(): ColorScheme {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}
